import React from "react";

const FreeDeliveryIcon = ({ size = 20 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none">
        <path
            fill="#6541E4"
            d="M6 2.31C7.952 1.181 8.928.618 10 .618s2.048.563 4 1.69l.66.382c1.952 1.127 2.928 1.69 3.464 2.618.536.929.536 2.056.536 4.31v.762c0 2.254 0 3.381-.536 4.31-.535.928-1.512 1.491-3.464 2.618l-.66.382c-1.952 1.127-2.928 1.69-4 1.69s-2.048-.563-4-1.69l-.66-.382c-1.952-1.127-2.928-1.69-3.464-2.618-.536-.929-.536-2.056-.536-4.31V9.62c0-2.254 0-3.381.536-4.31.536-.928 1.512-1.491 3.464-2.618L6 2.309Z"
        />
        <path
            fill="#fff"
            stroke="#6541E4"
            d="M9.995 5.877a3.77 3.77 0 0 0-3.77 3.77v3.56a2.42 2.42 0 0 0 2.42 2.42h2.699a2.42 2.42 0 0 0 2.42-2.42v-3.56a3.77 3.77 0 0 0-3.77-3.77Z"
        />
        <rect width="3.278" height="6.2" x="8.361" y="11.345" fill="#fff" stroke="#6541E4" rx="1.639" />
        <circle cx="1.874" cy="1.874" r="2.474" fill="#fff" stroke="#6541E4" transform="matrix(1 0 0 -1 8.12 7.248)" />
        <path stroke="#fff" d="m6.113 5.375 7.768-.001" />
    </svg>
);

export default FreeDeliveryIcon;
